// utils/images/imageManager.js
import axiosInstance from "utils/axiosInstance";
import {
  getImageFromIndexedDB,
  saveImageToIndexedDB,
} from "./indexedDBImageCache";
import { resizeImage } from "./resizeImage";

// Upload file to backend
export async function uploadImage(file, prefix = Date.now()) {

  const resized = await resizeImage(file); // ← Resize before uploading

  const filename = `${prefix}_${file.name}`;
  const formData = new FormData();
  formData.append("image", resized, file.name);

  await axiosInstance.post(`/knovia/uploadImage/${filename}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return filename; // You can store and reuse this
}

// Fetch image (and optionally cache it)
/*
export async function fetchImage(filename, size = "original", useCache = true) {
  const cacheKey = `${filename}_${size}`;

  if (useCache) {
    const cachedBlob = await getImageFromIndexedDB(cacheKey);
    if (cachedBlob) return URL.createObjectURL(cachedBlob);
  }

  const endpoint =
    size === "small"
      ? `/viewImageSmall/${filename}`
      : `/viewImage/${filename}`;

  const res = await axiosInstance.get(`knovia/${endpoint}`, { responseType: "blob" });
  const blob = new Blob([res.data], { type: res.headers["content-type"] });

  if (useCache) {
    await saveImageToIndexedDB(cacheKey, blob);
  }

  return URL.createObjectURL(blob);
}
*/

export async function fetchImage(filename, size = "original", useCache = true) {
  const cacheKey = `${filename}_${size}`;

  if (useCache) {
    const cachedBlob = await getImageFromIndexedDB(cacheKey);
    if (cachedBlob) {
      return { blob: cachedBlob, cacheKey };
    }
  }

  const endpoint =
    size === "small"
      ? `viewImageSmall/${filename}`
      : `viewImage/${filename}`;

  const res = await axiosInstance.get(`knovia/${endpoint}`, { responseType: "blob" });
  const blob = new Blob([res.data], { type: res.headers["content-type"] });

  if (useCache) {
    await saveImageToIndexedDB(cacheKey, blob);
  }

  return { blob, cacheKey };
}










